<template>
    <section id="how-it-works" class="py-5">
		<div class="container">
			<h2 class="text-center uc mb-5">How it works?</h2>
			<div class="row justify-content-center mb-5">
				<div class="col-xl-10">
					<div class="row mb-5 mb-lg-0">
						<div class="col-3 col-sm-2 col-lg-2 text-center order-lg-last">
							<div class="hiw-step">
								<img src="images/hiw_step1.png" alt="step 1">
								Step 01
							</div>
						</div>
						<div class="col-9 col-sm-10 col-lg-5"><h3>Lendsmark's easy-bake two minute form</h3>
							You only need to answer a few basic questions about your identity, employment and income. Our simple form makes for fast, secure and easy processing. In just a few minutes if approved, you’ll be ready to review your offer.
						</div>
						
					</div>
					<div class="row mb-5 mb-lg-0 justify-content-end">
						<div class="col-3 col-sm-2 col-lg-2 text-center">
							<div class="hiw-step">
								<img src="images/hiw_step2.png" alt="step 2">
								Step 02
							</div>
						</div>
						<div class="col-9 col-sm-10 col-lg-5"><h3>We'll search for a loan for you</h3>
							Grab yourself a coffee, while we shake the money tree for you. In a couple of minutes we’ll search for a loan from our network of lenders. If you are accepted by a lender, you’ll be forwarded to their acceptance page.
						</div>
					</div>
					<div class="row mb-5 mb-lg-0">
						<div class="col-3 col-sm-2 col-lg-2 text-center order-lg-last">
							<div class="hiw-step">
								<img src="images/hiw_step3.png" alt="step 3">
								Step 03
							</div>
						</div>
						<div class="col-9 col-sm-10 col-lg-5"><h3>Review the terms and sign an agreement</h3>
							Carefully review the terms and conditions of the offer. An E-Sign page will be presented by the lender to complete the process. If you do not like the terms of the loan, you are under no obligation to accept.
						</div>
					</div>
					<div class="row mb-5 mb-lg-0 justify-content-end">
						<div class="col-3 col-sm-2 col-lg-2 text-center">
							<div class="hiw-step last">
								<img src="images/hiw_step4.png" alt="step 4">
								Step 04
							</div>
						</div>
						<div class="col-9 col-sm-10 col-lg-5"><h3>Receive the funds to your account and start spending</h3>
							After your sign your agreement your funds will be transferred to your account usually within 24-48 hours depending on the conditions of the loan agreement. Remember to use any loan responsibly.
						</div>
					</div>
				</div><!--End Col 10-->
			</div><!--End Row-->
			<div class="call-to-action text-center">
				<HomeLeadFormButton v-if="mode != 'hash'" />
                <div v-else>
                    <a href="#step-1" class="btn btn-cta uc" v-scroll-to="'#step-1'">Get Started</a>
                </div>
			</div>
		</div><!--End Container-->
	</section>
</template>

<script>
import HomeLeadFormButton from '@/components/home/HomeLeadFormButton.vue';

export default {
    name: 'HowItWorks',
    components: {
        HomeLeadFormButton
    },
    props: {
        mode: {
            type: String,
            default: "history"
        }
    }
}
</script>

<style>

</style>
